import { render, staticRenderFns } from "./FavoriteDetail.vue?vue&type=template&id=08519223&scoped=true&"
import script from "./FavoriteDetail.vue?vue&type=script&lang=js&"
export * from "./FavoriteDetail.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteDetail.vue?vue&type=style&index=0&id=08519223&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08519223",
  null
  
)

export default component.exports